import { HttpService } from "services";
import { AuthorizationLevel } from "types/http";
import {
  GetTitleCompaniesFunction,
} from "types/functions/getTitleCompanies";
import { TitleCompanies } from "types/entities";

/**
 * Retrieve title companies
 *
 * @throws {HttpServiceException}
 */
export const getTitleCompanies: GetTitleCompaniesFunction = async () => {
  try {
    const url = "/title-company";

    const res: TitleCompanies[] = await HttpService.fetch(
      url,
      {
        requestConfig: {
          method: "GET",
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return res;
  } catch (error) {
    throw error;
  }
};
